RivalIQ.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.Token = Backbone.Model.extend({
        _hasFbPermission: function (permission) {
            const me = this;
            return _.get(me.get('token_metadata'), ['grantedScopes', permission]) === RivalIQ.enums.token.permission.GRANTED;
        },

        hasFbInsights: function () {
            const me = this;
            return me._hasFbPermission('read_insights') && me._hasFbPermission('pages_read_engagement');
        },

        hasFbAdsRead: function () {
            const me = this;
            return me._hasFbPermission('ads_read');
        },

        hasInstagramInsights: function () {
            const me = this;
            return me._hasFbPermission('instagram_basic') && me._hasFbPermission('instagram_manage_insights');
        }
    });

});
